<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      v-if="isBatchCategory"
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%">
      <section>
        <div class="conf">
          <el-form-item label="商品分类:" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :baseItemId="baseItemId" :platform="platform" />
            </div>
          </el-form-item>
          <!-- <el-form-item v-if="validateFieldMap.checkNameBrand || validateFieldMap.popNameLength" label="商品标题" prop="title">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.title"
              :maxlength="!validateFieldMap.popNameLength ? 50 : 60"
              :show-word-limit="!validateFieldMap.popNameLength"
            >
              <template v-if="validateFieldMap.checkNameBrand && needShowBrandTitle" slot="prepend">
                {{ brandName.brandName }}
                <el-tooltip popper-width="200px" effect="dark" content="该处仅做示例，铺货到铺后以各店铺选择的品牌词为准" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-input>
          </el-form-item> -->
          <el-form-item v-if="shopList.length" label="品牌" prop="brandId">
            <BrandIdBlock
              ref="brandIdBlock"
              :baseItemId="baseItemId"
              :categoryIds="self_form.categoryIds"
              v-model="self_form.brandId"
              :shopList="shopList"
              />
          </el-form-item>
          <el-form-item v-show="self_form.categoryIds.length" label="商品属性">
            <UseCategoryTemplate 
              :supportAIPre="false"
              :categoryIds="self_form.categoryIds" 
              :platform="platform" 
              :baseItemId="baseItemId" 
              :propValues="self_form.itemPropValues"
              @clickFill="clickTemPlateFill"
            >
              <CategoryProps
                ref="cateprops"
                propConfigType="item"
                v-model="self_form.itemPropValues"
                :categoryIds="self_form.categoryIds"
                @prop4get="prop4get"/>
            </UseCategoryTemplate>
          </el-form-item>
        </div>
      </section>
    </el-form>
    <el-form
      v-else
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类:" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" :baseItemId="baseItemId" v-model="self_form.categoryIds" :platform="platform" :isSupportAi="true"/>
            </div>
          </el-form-item>
          <el-form-item label="商品标题" prop="title">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.title"
              :maxlength="validateFieldMap.popNameLength || 100"
            >
              <template v-if="validateFieldMap.checkNameBrand && needShowBrandTitle" slot="prepend">
                {{ brandName.brandName }}
                <el-tooltip popper-width="200px" effect="dark" content="该处仅做示例，铺货到铺后以各店铺选择的品牌词为准" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <span slot="suffix" style="margin-right: 6px;">{{ textLength(self_form.title) }}/{{validateFieldMap.popNameLength || 100}}</span>
            </el-input>
          </el-form-item>
          <el-form-item v-if="shopList.length" label="品牌" prop="brandId">
            <BrandIdBlock
              ref="brandIdBlock"
              v-model="self_form.brandId"
              :shopList="shopList"
              :baseItemId="baseItemId"
              :categoryIds="self_form.categoryIds"
              />
          </el-form-item>
          <template v-if="!validateFieldMap.popNameLength">
            <el-form-item label="商品标语" prop="slogan">
              <el-input
                type="text"
                placeholder="商品标语用来介绍商品特点，吸引用户购买，若有促销宣传语时将会覆盖商品标语"
                v-model="self_form.slogan"
                maxlength="80"
                show-word-limit
              >
              </el-input>
              <div style="font-size: 12px">“商品标语”+“标语链接”文字最多输入80个字符（汉字、英文字母、标点、数字均算一个字符）</div>
            </el-form-item>
            <el-form-item label="">
              <div class="gray-block">
                <el-form-item style="margin-bottom: 16px" label="标语加链接的文字" label-width="106px" prop="sloganLinkWord">
                  <el-input
                    :disabled="!self_form.slogan"
                    type="text"
                    placeholder="不能含有特殊字符或者HTML标签"
                    v-model="self_form.sloganLinkWord"
                    maxlength="30"
                    show-word-limit
                  >
                  </el-input>
                  <div style="font-size: 12px">“标语加链接文字”在“商品标语”后面展示</div>
                </el-form-item>
                <el-form-item label="标语链接地址" label-width="106px" prop="linkAddress">
                  <el-input
                    :disabled="!self_form.slogan"
                    type="text"
                    placeholder="请使用jd.com、360buy.com或jd.hk、360buy.hk或isvjcloud.com的链接!"
                    v-model="self_form.linkAddress"
                    maxlength="95"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
              </div>
            </el-form-item>
          </template>
        </div>
      </section>

      <section>
        <div class="title ft-12">
          <span>商品参数</span>
        </div>
        <div class="conf" style="padding: 0 125px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="货号：" prop="itemNum" labelWidth="105px">
                <el-input
                  type="text"
                  placeholder="请输入"
                  v-model="self_form.itemNum"
                  style="width: 200px"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产地：" prop="wareLocation" labelWidth="105px">
                <el-select v-model="self_form.wareLocation" filterable clearable placeholder="请选择" style="width: 200px">
                  <el-option
                    v-for="item in prodLocalOptions"
                    :key="item.id"
                    :label="item.locationName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="UPC编码：" prop="upcCode" labelWidth="105px">
                <el-input
                  type="text"
                  placeholder="请输入"
                  v-model="self_form.upcCode"
                  style="width: 200px"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="[包装]长(mm)：" prop="length" labelWidth="105px">
                <el-input-number
                  class="number-input"
                  style="width: 200px"
                  v-model.number="self_form.length"
                  :controls="false"
                  :precision="0"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="[包装]宽(mm)：" prop="width" labelWidth="105px">
                <el-input-number
                  class="number-input"
                  style="width: 200px"
                  v-model.number="self_form.width"
                  :controls="false"
                  :precision="0"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="[包装]高(mm)：" prop="height" labelWidth="105px">
                <el-input-number
                  class="number-input"
                  style="width: 200px"
                  v-model.number="self_form.height"
                  :controls="false"
                  :precision="0"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品毛重(公斤)" prop="weight" labelWidth="105px">
                <el-input-number
                  class="number-input"
                  style="width: 200px"
                  v-model.number="self_form.weight"
                  :controls="false"
                  :precision="3"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密度(g/cm3)" prop="density" labelWidth="105px">
                <el-input-number
                  class="number-input"
                  disabled
                  placeholder="商品毛重/包装长*包装宽*包装高"
                  style="width: 200px"
                  :value="density"
                  :controls="false"
                  :precision="2"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </section>

      <section>
        <div class="title ft-12">
          <span>商品属性</span>
        </div>
        <div class="conf">
          <el-form-item label="属性">
            <UseCategoryTemplate 
                :categoryIds="self_form.categoryIds" 
                :detailHasCategory="detailHasCategory" 
                :platform="platform" 
                :baseItemId="baseItemId" 
                :propValues="self_form.itemPropValues"
                @clickFill="clickTemPlateFill"
               >
            <CategoryProps
              ref="cateprops"
              propConfigType="item"
              v-model="self_form.itemPropValues"
              :categoryIds="self_form.categoryIds"
              @prop3get="prop3get"
              @prop4get="prop4get"/>
              </UseCategoryTemplate>
          </el-form-item>
          <el-form-item label="发货时效" prop="promiseConfig" v-if="promiseConfList.length">
            <template v-if="promiseConfList.length">
              <PromiseConfig
                :promiseConfList="promiseConfList"
                :values="promiseTemplateValues"
                @change="validPage"
              />
            </template>
            <div v-else class="no-shops">暂无平台店铺</div>
            <!-- <div style="color:red; font-size: 12px;">注意：京东平台发货时效模版必填，规格商品未配置，会继承主商品发货时效模板，若均未配置会导致铺货失败！</div> -->
          </el-form-item>
        </div>
      </section>

      <section>
        <div class="title ft-12">
          <span>销售属性</span>
        </div>
        <div class="conf">
          <template v-if="colorIds.length">
            <el-form-item label="商品规格:" prop="skuAttrs">
              <RuleSortBtn :specifications.sync="specifications" />
              <SpecsValuesSort :specifications.sync="specifications" />
              <JDSpecification
                ref="jdSpecification"
                v-model="specifications"
                :allSaleProps="allSaleProps"
                :changeToBase="changeToBase"
                :unrenderSpecList="unrenderSpecList"
                :needlessSpecList="needlessSpecList"
                :isPlatform="true"
                :isCheckImg="isCheckSkuImg"
                @file-upload="imageUpload"
                @specNameChanged="handleSpecNameChanged"
              />
            </el-form-item>
            <el-form-item label="规格明细:" prop="skuAttrsDetail">
              <FormItemSkuList
                :specifications="specifications"
                :baseItemId="baseItemId"
                skuSpecificationsKey="skuSpecifications"
                :tableCols="skuTableCols"
                v-model="skuList"
                @fieldChanged="specificationsFieldChanged"
              >
                <template slot="skuBatchSlot" v-if="this.showSearchImgType">
                  <el-button type="default" @click="batchSetSearchImages">批量设置搜索推荐图</el-button>
                </template>
                <template slot="promiseHeaderSlot">
                  <span style="color: red" >*</span> 发货时效
                  <div style="height: 24px;line-height: 24px;display: block;padding: 0;"><el-button type="link" @click="toPromiseConfig()">批量设置</el-button></div>
                </template>
                <template slot="promiseSlot" slot-scope="{ row }">
                  <span :style="{color: getPromiseText(row) == '未配置' ? 'red': '#303133'}">{{ getPromiseText(row) }}</span>
                  <el-button type="text" @click="toPromiseConfig(row)">设置</el-button>
                </template>
                <template slot="skuEnableSlot" slot-scope="{ row }">
                  <el-switch
                    v-model="row.skuEnable"
                    :active-value="1"
                    :inactive-value="2"
                    disabled
                  />
                </template>
                <template slot="whiteBackGroundPicUrlSlot" slot-scope="{ row,$index }">
                  <div style="margin: 6px 0;"> 
                    <ImgUpload
                        :ref="`whiteBackGroundPicUrl_${$index}`"
                        :width="80"
                        :height="80"
                        :size="120"
                        :file="row.whiteBackGroundPicUrl || ''"
                        @upload-success="(url) => handleSkuListPic(row, url, 'whiteBackGroundPicUrl')"
                        @del="() => handleSkuListPic(row, '', 'whiteBackGroundPicUrl')"
                        @handleLoad="handleImgLoad(row, `whiteBackGroundPicUrl`, $index)"
                        :isSingle="true"
                        limitSuffix=".jpg,.jpeg" 
                      />
                      <div style="color: red;white-space: normal;" class="el-form-item__error" v-if="row.whiteBackGroundPicUrl_errMsg">{{ row.whiteBackGroundPicUrl_errMsg }}</div>
                  </div>
                </template>
                <template slot="searchImagesSlot" slot-scope="{ row,$index }">
                  <div style="margin: 6px 0;">
                      <ImgUpload
                        :ref="`searchImages_${$index}`"
                        :file="row.searchImages"
                        :isSingle="true"
                        :key="JSON.stringify(autoCropImageConfigList)"
                        :isCheckImg="isCheckSearchImg"
                        v-bind="searchImageLimits"
                        @upload-success="url => handleSkuListPic(row, url, 'searchImages')"
                        @del="() => handleSkuListPic(row, '', 'searchImages')"
                        @handleLoad="handleImgLoad(row, `searchImages`, $index)"
                      />
                      <div style="color: red;white-space: normal;" class="el-form-item__error" v-if="row.searchImages_errMsg">{{ row.searchImages_errMsg }}</div>
                  </div>
                </template>
                  <template slot="skuImageHeaderSlot">
                    规格图
                    <div style="line-height: 24px;display: block">
                      <el-button type="link" @click="switchSkuImageType"><i class="el-icon-swap"></i> {{ skuImageType === 34 ? '使用1:1' : '使用3:4' }}</el-button>
                    </div>
                  </template>
                  <template slot="skuImageSlot" slot-scope="{ row,$index }">
                  <div style="margin: 6px 0;">
                      <ImgUpload
                        :ref="`skuImage_${$index}`"
                        :file="row.skuImage"
                        :isSingle="true"
                        v-bind="skuImageLimits"
                        @upload-success="url => handleSkuListPic(row, url, 'skuImage')"
                        @del="() => handleSkuListPic(row, '', 'skuImage')"
                        @handleLoad="handleImgLoad(row, `skuImage`, $index)"
                      />
                      <div style="color: red;white-space: normal;" class="el-form-item__error" v-if="row.skuImage_errMsg">{{ row.skuImage_errMsg }}</div>

                  </div>
                </template>
                <template slot="skuPropHeaderSlot">
                  <span style="color: red" v-if="skuPropList.filter(item=>item.isRequired).length">*</span> SKU属性
                  <div style="height: 24px;line-height: 24px;display: block;padding: 0;"><el-button type="text" @click="editSkuCateprops({}, true)">批量设置</el-button></div>
                </template>
                <template slot="skuPropSlot" slot-scope="{ row }">
                  <el-button type="link" @click="editSkuCateprops(row)">SKU属性</el-button>
                </template>
                <template slot="nutrientContentHeaderSlot">
                  食品安全
                  <div style="height: 24px;line-height: 24px;display: block;padding: 0;"><el-button type="text" @click="editNutrientContent({}, true)">批量设置</el-button></div>
                </template>
                <template slot="nutrientContentSlot" slot-scope="{ row }">
                  <el-button type="link" @click="editNutrientContent(row)">{{ getNutrientBtnText(row.nutrientContent) }}</el-button>
                </template>
              </FormItemSkuList>
              <template v-if="specificationsValidResult !== true">
                <div class="el-form-item__error">{{specificationsValidResult}}</div>
              </template>
            </el-form-item>
            <el-form-item label="京东价（元）" prop="jdPrice">
              <el-input-number
                class="number-input"
                style="width:120px"
                v-model.number="self_form.jdPrice"
                :controls="false"
                :min="0.01"
                :max="999999999.99"
                :precision="2"
              />
            </el-form-item>
            <el-form-item label="市场价（元）" prop="marketPrice">
              <el-input-number
                class="number-input"
                ref="price"
                style="width:120px"
                v-model.number="self_form.marketPrice"
                :controls="false"
                :min="0.01"
                :max="999999999.99"
                :precision="2"
              />
            </el-form-item>
            <el-form-item label="折扣">
              <el-input
                ref="price"
                type="text"
                disabled
                placeholder="京东价/市场价"
                v-model="discount"
                style="width: 120px"
              >
              </el-input>%
            </el-form-item>
          </template>
          <template v-else>
            <div style="text-align: center; padding: 10px 0 20px; font-weight: bold; font-size: 14px;">暂无</div>
          </template>
        </div>
      </section>

      <section v-if="colorIds.length">
        <div class="title ft-12">
          <span>商品图片</span>
        </div>
        <div class="conf">
          <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
            <GroupImagesList :baseItemId="baseItemId" :specifications="specifications" :hideImgs="['mainImages34']"  @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
          </el-form-item>
          <div 
            v-for="colorId in colorIds"
            :key="colorId"
          >
            <el-form-item
              :style="colorId === '0000000000' ?'':'margin-bottom:0'"
              :label="colorId === '0000000000' ? '商品图片' : getSpItem(colorId, 'value')">
              <div style="margin-bottom: 10px" v-if="colorId === '0000000000'">
                <el-button @click="pushSkuImg">一键追加到所有sku图</el-button>
                <el-button @click="coverSkuImg">一键覆盖到所有SKU图</el-button>
              </div>
              <div style="margin-bottom: 10px" v-if="colorId !== '0000000000'">
                <el-button @click="applyMainImg(colorId)">使用商品图片</el-button>
              </div>
              <div>
                <ImageBlock
                  :key="JSON.stringify(autoCropImageConfigList)"
                  :ref="'IB-' + colorId"
                  :colorId="colorId"
                  :images="imagesMap[colorId]"
                  :imagesLimits="imagesMainLimits"
                  tipText="图片至少上传1张，最多10张，大小不超过3M，比例要求1:1, 尺寸不得低于480px*480px，建议尺寸1440px*1440px,仅支持jpg、jpeg、png格式，您可以拖拽图片调整顺序"
                  :transparentImages="transparentImagesMap[colorId]"
                  :showSettingSearchImgBtn="showSearchImgType && sstjggCat == 1 && colorId !='0000000000'"
                  @change="imageBlockChange(colorId)"
                  :imagesLength="colorIds.length"
                  :isCheckImg="isCheckMainImg"
                  @grandparentImageUrlSetSearchChanged="imageSettingBlockChangeSearchImg"
                  :autoCropImageParams="{publishAutoCropImageEnum:colorId === '0000000000' ? 'JD_MainImg':'JD_SkuImg'}"
                />
              </div>
            </el-form-item>
            <el-form-item v-if="showLongImage" :label="colorId === '0000000000' ? '商品长图' : ''">
                    <div style="margin-bottom: 10px" v-if="colorId === '0000000000'">
                        <el-button @click="pushSkuLongImg">一键追加到所有sku长图</el-button>
                        <el-button @click="coverSkuLongImg">一键覆盖到所有SKU长图</el-button>
                    </div>
                    <ImageBlock
                    :ref="'IB-Long' + colorId"
                    :key="JSON.stringify(autoCropImageConfigList)"
                    :colorId="colorId"
                    :titleText="colorId == '0000000000' ? '长图展示图' : '规格长图' "
                    :images="lengthImagesMap[colorId]"
                    :imagesLimits="imagesLengthLimits"
                    tipText="图片最多10张，大小不超过3M，比例要求3:4, 尺寸不得低于480px*480px，建议尺寸1440px*1920px，仅支持jpg、jpeg、png格式，您可以拖拽图片调整顺序"
                    :transparentImages="transparentImagesMap[colorId]"
                    :showSettingSearchImgBtn="showSearchImgType && sstjggCat == 2  && colorId !='0000000000'"
                    :isCheckImg="colorId == '0000000000' ? isCheckMainLengthImg:isCheckSkuLengthImg"
                    :autoCropImageParams="{publishAutoCropImageEnum:colorId === '0000000000' ? 'JD_MainLengthImg':'JD_SkuLengthImg'}"
                    @change="imageBlockLongChange(colorId)"
                    :imagesLength="colorIds.length"
                    @grandparentImageUrlSetSearchChanged="imageSettingBlockChangeSearchImg"
                  />
            </el-form-item>
          </div>
        </div>
      </section>
       
      <section>
        <div class="title ft-12">
          <span>商品描述</span>
        </div>
        <div class="conf">
          <el-form-item :class="editorFormItenClass" label="电脑版商品详情" prop="introduction">
            <Editor id="pc" :limitImgSize="3 * 1024 * 1024" v-model="self_form.introduction" @fullScreenChange="editorFullScreenChange" />
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <div
                >1、满足规范标准且含有必备模块，按品类筛查参考<el-link  href="http://psm.jd.com/index.html" target="_blank">《京东商品管理标准系统》</el-link>；</div
              >
              <div
                >2、每张宽度建议640像素，所有图片宽度一致；</div
              >
              <div
                >3、每张高度小于等于960像素；</div
              >
              <div
                >4、每张图片容量应小于等于3000kb；</div
              >
              <div
                >5、图片格式为：JPG\GIF\PNG；</div
              >
              <div
                >6、图片总张数建议大于5张，但不超过30张；</div
              >
              <div
                >7、为了更好的视觉呈现，图片上的文字字号建议不小于20号；</div
              >
              <div
                >8、基于平台体验及转化提升计划，自2020年6月1日起屏蔽所有活动、商品推荐的跳转链接，相关内容请前往关联版式进行设置。</div
              >
            </div>
          </el-form-item>
        </div>
      </section>

      <section>
        <div class="title">
          <span>商品售后</span>
        </div>
        <div class="conf">
          <el-form-item label="包装清单" prop="packListing">
            <el-input
              type="textarea"
              placeholder="请输入"
              v-model="self_form.packListing"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="售后服务" prop="afterSales">
            <el-input
              type="textarea"
              placeholder="请输入"
              v-model="self_form.afterSales"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="质保期" prop="features.zbxx" :rules="[{required: zbxx_required, message: '请选择质保期', trigger: 'change'}]">
            <el-select v-model="self_form.features.zbxx" placeholder="请选择质保期" clearable style="width: 200px">
              <el-option
                v-for="item in warrantyPeriodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
      </section>
       <!-- 运费模板 -->
              <section>
                <div class="title ft-12">
                  <span>运费模板</span>
                </div>
                <div class="conf">
                  <el-form-item label="运费设置：">
                    <el-row v-if="shopList.length && shipsValue">
                      <el-col v-for="shop in shopList" :key="shop.id" :span="12" class="set-ship">
                        <el-image
                          :src="shop.icon"
                          style="width: 26px; height: 26px;  border-radius: 50%"
                          ></el-image>
                          <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                            <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                          </el-tooltip>
                          <span class="shop-title">{{ shop.simpleTitleConfig === 1 ? (shop.shortTitle || shop.title ): shop.title }}</span>
                          <el-select 
                            v-model="shipsValue[shop.id]" 
                            placeholder="请选择运费模板"
                            clearable
                            :value-key="String(shop.id)"
                            @visible-change="changeSelect(shop.id, shop.userId)"
                            >
                            <el-option
                              v-for="ship in shipsTemplate[shop.id]"
                              :key="ship.id"
                              :label="ship.name"
                              :value="ship.id"
                              >
                            </el-option>
                          </el-select>
                          <span v-if="getTemplateFail[shop.id]" style="color: red;margin-left: 10px; font-size: 12px;">店铺授权已失效</span>
                      </el-col>
                    </el-row>
                    <span v-else class="no-shops">暂无平台店铺</span>
                  </el-form-item>
                </div>
              </section>
              <!-- 上架设置 -->
              <section>
                <div class="title ft-12">
                  <span>上架设置</span>
                </div>
                <div class="conf">
                  <el-form-item 
                    label="上架设置:" 
                    :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
                      <el-radio-group v-model="isOnshelf">
                          <el-radio :label="1">立即上架</el-radio>
                          <el-radio :label="2">放入草稿箱</el-radio>
                      </el-radio-group>
                  </el-form-item>
                </div>
              </section>
    </el-form>
    <PromiseConfigDialog ref="PromiseConfigDialogRef"/>
    <SkuCategoryPropDialog ref="SkuCategoryPropDialogRef"/>
    <SetSearchImages ref="SetSearchImagesRef" :imageLimits="searchImageLimits" :sstjggCat="sstjggCat"/>
    <NutrientContentDialog ref="NutrientContentDialogRef"/>
  </div>
</template>
<script>
import "@/assets/css/prod.scss";
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import ImgUpload from "@/components/Uploads/ImgUpload";
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryProps from './CategoryProps.vue'
import SkuCategoryPropDialog from "./SkuCategoryPropDialog.vue";
import SetSearchImages from "./SetSearchImages.vue";
import CategoryInput from "../PlatformCategoryInput/index.vue";
import ReuseLastCategory from "../PlatformCategoryInput/ReuseLastCategory.vue";
import ImageBlock from './ImageBlock.vue';
import BrandIdBlock from './BrandIdBlock.vue';
import PromiseConfig from './PromiseConfig.vue';
import PromiseConfigDialog from './PromiseConfigDialog.vue';
import NutrientContentDialog from './NutrientContentDialog.vue';

import RULES, {validateTitle, validateTitle2, validateBrandId, validatePromise, contextWrap, validateSkuPrice} from "./rules.js";

import {specification_mixin} from '../FormItemSpecification'
import validateMixin from '../validateMixin';
import {editor_mixin} from '@/components/Editor/index.js'
import { cloneDeep } from "lodash";
import JDSpecification from './JDSpecification.vue';

import {
  getJdNeedValidateField,
  getIsShowLengthWidthHeight,
  getJdNoShowBrandId,
  getJdSellerDeliverySendPromiseTemplate,
  getCategoryFeature,
  getJdSaleAttrs,
  getJdSchemas,
  getJdCategoryRuleTemplatesComponents,
  // upload
} from '@/servers/prod/center/jd.js'
import {getDistributionConfig, getJdTemplates} from '@servers/prod/conf/index.js'
import {mapGetters, mapActions} from 'vuex'
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import { gernerateJDSpecs } from './service';
import { getBytesCount } from "@utils/data"
import shopListMixin from '../shopListMixin';
import { warrantyPeriodOptions, nutrientContentSchemaRules } from './dictionary';


export default {
  mixins: [specification_mixin, editor_mixin, validateMixin, shopListMixin],
  provide() {
    return {
      noSpPic: true,
      disabledSpName: true,
      platform: "jd",
      openSource:this.openSource,
      $parent: this,
    }
  },
  inject: {
    isGroupPuhuo: {
      form: 'isGroupPuhuo',
      default: false
    },
    isBatchCategory: {
      from: 'isBatchCategory',
      default: false
    },
  },
  components: {
    MutiImgUpload,
    ImgUpload,
    GroupImagesList,
    CategoryInput,
    CategoryProps,
    SkuCategoryPropDialog,
    SetSearchImages,
    ReuseLastCategory,
    ImageBlock,
    BrandIdBlock,
    PromiseConfig,
    PromiseConfigDialog,
    NutrientContentDialog,
    JDSpecification,
    UseCategoryTemplate,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    shopsList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      isJd: true,
      platform: "jd",
      warrantyPeriodOptions,
      // mustSpTipsArr: [], // 必须的规格信息提示
      self_form: {},
      rules: RULES(this),
      skuPropList: [],
      skuSpecificationsKey: 'skuSpecifications',
      showGroupImages: true,
      imagesMap: null, // 商品图片集合
      lengthImagesMap: null,//商品长图集合
      transparentImagesMap: null, // 商品透图的集合 

      brandIdOptions: [], // 品牌选项列表
      shops: [], // 店铺id及名称数组
      showSpecialFormItem: false, // 是否展示特殊表单
      shipsTemplate: {}, // 运费模板列表
      shipsValue: {}, // 运费模板值
      promiseConfList: [], // 发货时效的支持设置的店铺
      skuPromiseConfList: [],
      promiseTemplateValues: {},  // 发货时效值
      skuImageType: 11, // 规格图类型 11: 1:1 34: 3:4
      templateConfigMap: {}, // 初始值
      originalTemplateConfig: null,
      originalShopBrandConf: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
      getTemplateFail: {}, // 获取运费模板失败
      isOnshelf: 1,
      isShowLWH: false,
      isWeight:false,
      isVolume:false,
      validateFieldMap: {}, // 当前类目下的新校验字段 'checkNameBrand', 'popNameLength'
      noShowBrandId: [], // 不需要回显在title中的品牌id
      saleAttrs: [],
      requestedSaleAttrs: false,
      unrenderSpecList: [],
      needlessSpecList: [],
      allSaleProps: [],
      searchImages: [],
      detailHasCategory: [],
      detailCategoryId: '',
      detailCategoryIdChange: false,
      platform: 'jd',
      showSearchImgType: '', 
      sstjggCat: '', // 
      skuListImgErrMsgs: {},// skuList图片错误信息
      autoCropImageConfigList:[],
      showLongImage: '',// 是否显示长图
      zbxx_required: false, // 质保期是否必填
      schemas: {},
      nutrientContentSchemaRules: null, // 食品安全渲染规则
    };
  },
  computed: {
    ...mapGetters(['shops_getCategoryPropShopId']),
    shopList() {
      let list = this.getShopList(this.platform);
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list;
    },
    shopId() {
      return this.shops_getCategoryPropShopId('jd')
    },
    categoryId() {
      return this.getCategoryId()
    },
    SkuNutrientContentComponent() {
      return this.schemas?.componentList?.find(s => s.componentCode === "SKUS")?.childrenComponents?.find(c => c.componentCode === "SkuNutrientContent")
    },
    skuTableCols() {
      const origin_form = JSON.parse(localStorage.getItem('_origin_form'));
      let openSource = this.openSource
      let isShowPreviewPrice = true;
      if(['taskCenter','previewPublish'].includes(openSource)){
          isShowPreviewPrice = false
      }
      const cols =[
        {prop: 'searchImages', 
          attrs: { width: 100, label: '搜索推荐图',noRequired: this.showSearchImgType =='2'? false : true},
          input: { type:'img', showSearchImgType: this.showSearchImgType, onlyTable: true },
          slot: true,
          unvisible: !this.showSearchImgType
        },
        {prop: 'salesPrice', attrs: {label: '销售价', noRequired: true}},
        {prop: 'whiteBackGroundPicUrl', attrs: { width: 100,label: 'sku白底图', noRequired: true}, slot: true},
        { prop: 'skuImage', attrs: {label: '规格图', noRequired: true, width: 100 }, slot: true, headerSlot: true },
        {prop: 'promise', attrs: {label: '发货时效' }, slot: true, headerSlot: true, unvisible: !this.skuPromiseConfList.length},
        {prop: 'jdPrice', attrs: {label: '京东价'}, input: {type: 'number', validator: validateSkuPrice, attrs: {maxlength: 13, max: 999999999}}, previewPrice: isShowPreviewPrice},
        { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true }, unvisible: origin_form?.isDistribution == 0? true : false ,},
        {prop: 'barCode', attrs: {label: 'UPC编码', noRequired: true}, input: {type: 'text'}},
        this.openSource != 'shopGoods' ? {prop: 'outerSkuId', attrs: {label: '商家编码', noRequired: this.isGroupPuhuo}} : null,
        {prop: 'skuProp', attrs: {label: 'SKU属性'}, slot: true, headerSlot: true, unvisible: !this.skuPropList.length },
        {prop: 'nutrientContent', attrs: {label: '食品安全', width: 120 }, slot: true,headerSlot: true, unvisible: !this.SkuNutrientContentComponent },
        {prop: 'stockNum', attrs: {label: '库存', noRequired: true}, input: {type: 'number'}},
        {prop: 'skuEnable', attrs: {label: '商品状态'}, slot: true},
      ]
      return cols.filter(Boolean)
    },
    searchImageLimits() {
      const limits = {
        width: 80,
        height: 80,
        size: 100,
        limitSize: this.isCheckSearchImg ? 1024 * 1024 * 3 : 0,
        limitWidth: this.isCheckSearchImg ? [480, 1125] : [0,0], 
        limitHeight: this.isCheckSearchImg ? [640, 1500] : [0,0], 
      }
      if(this.isCheckSearchImg){
        if (this.sstjggCat == '2') {
          limits.aspectRatio = [0.75]
          limits.aspectRatioText = '3:4'
        } else {
          limits.aspectRatio = [1]
          limits.aspectRatioText = '1:1'
        }
      }
      return limits
    },
    imagesLengthLimits() {
      const limits = {
        limitSize: 1024 * 1024 * 3,
        size: 100,
        limitWidth: [480, 0], 
        limitHeight: [480, 0], 
        mainImgNums: 0,
        limitNums: 10,
        aspectRatio: [0.75],
        aspectRatioText: '3:4',
        limitSuffix: '.jpg,.jpeg,.png',
      }
      return limits
    },
    imagesMainLimits() {
      const limits = {
        limitSize: 1024 * 1024 * 3,
        size: 100,
        limitWidth: [480, 0], 
        limitHeight: [480, 0], 
        mainImgNums: 0,
        limitNums: 10,
        aspectRatio: [1],
        aspectRatioText: '1:1',
        limitSuffix: '.jpg,.jpeg,.png',
        supportAiRetry: true
      }
      return limits
    },
    skuImageLimits() {
      const limits = {
        width: 80,
        height: 80,
        limitSize: 1024 * 1024 * 3,
        size: 100,
        limitSuffix: '.jpg,.jpeg,.png',
      }
      if (this.skuImageType == 34) {
        limits.aspectRatio = [0.75]
        limits.aspectRatioText = '3:4'
      } else {
        limits.aspectRatio = [1]
        limits.aspectRatioText = '1:1'
      }
      return limits
    },
    // 产地列表
    prodLocalOptions() {
      return this.$store.getters.jd_wareLocation
    },
    // 颜色sku的colorIds集合
    colorIds() {
      if (!this.imagesMap || !this.transparentImagesMap) return []
      const colorIds =[] 
      Object.keys(this.imagesMap).concat(Object.keys(this.transparentImagesMap)).forEach(colorId => {
        if (colorIds.includes(colorId)) {
          return ;
        }
        if (colorId === '0000000000') {
          // 主图无需匹配规格值
          return;
        }
        const item = this.getSpItem(colorId)
        if (item && item.checked) {
          colorIds.push(colorId)
        }
      })
      colorIds.unshift('0000000000') // 主图需要在第一位
      return colorIds
    },
    // 商品密度
    density() {
      const {length, width, height, weight} = this.self_form
      if (!length || !width || !height || !weight) {
        return undefined
      }
      return ((weight / (length * width * height)) * 1000000).toFixed(2)
    },
    // 商品折扣
    discount() {
      const {jdPrice, marketPrice} = this.self_form
      if (!jdPrice || !marketPrice) {
        return undefined
      }
      return ((jdPrice / marketPrice) * 100).toFixed(0)
    },
    // 品牌名
    brandName() {
      let brandNameObj = null
      let shopIds = this.shopList.map(({id}) => id);
      (this.self_form?.brandId || []).forEach(item => {
        if (
          !shopIds.includes(item.shopId) ||
          item.brandId === -1 ||
          brandNameObj
        ) return;
        brandNameObj = item;
      })
      return brandNameObj ? brandNameObj : {
        brandId: -1,
        brandName: '无品牌'
      }
    },
    // 是否展示标题中的品牌部分
    needShowBrandTitle() {
      return !this.noShowBrandId.includes(this.brandName.brandId)
    },
    //商品展示图校验
    isCheckMainImg(){
        return this.isCheckImg('mainImg')
    },
    //商品长图校验
    isCheckMainLengthImg(){
        return this.isCheckImg('mainLengthImg')
    },
    //规格长图校验
    isCheckSkuLengthImg(){
        return this.isCheckImg('skuLengthImg')
    },
    //规格图校验
    isCheckSkuImg(){
        return this.isCheckImg('skuImg')
    },
    //搜索推荐图校验
    isCheckSearchImg(){
        return this.isCheckImg('searchImg')
    },
  },
  watch: {
    form: {
      handler(v) {
        if (v.templateConfig && v.templateConfig.length) {
          this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        // 保存原始 shopBrandConf，用于保存时恢复未显示店铺的数据
        if (v.shopBrandConf && v.shopBrandConf.length) {
          this.originalShopBrandConf = cloneDeep(v.shopBrandConf);
        }
        if (v.skuList?.length) {
          const { specifications = [], skuList = [] } = v;
          this.skuImageType = skuList[0].rectangleSpecImages ? 34 : 11
          // 按照外层的specifications 排序
          v.skuList = skuList.map(item => {
            const newSkuSpecifications = [];
            specifications.forEach(spec => {
              const matchItem = item[this.skuSpecificationsKey].find(skuSpec => skuSpec.nameKey === spec.nameKey);
              if (matchItem) {
                newSkuSpecifications.push(matchItem);
              }
            });
            const _skuid = newSkuSpecifications.map(sp => sp.valueKey).join('-')
            return {
              ...item,
              skuImage: this.skuImageType === 34 ? item.rectangleSpecImages : item.squareSpecImages,
              _skuid
            }
          })
        }

        let _form = {
          ...v,
          length: v.length || undefined,
          width: v.width || undefined,
          height: v.height || undefined,
          weight: v.weight || undefined,
          jdPrice: v.jdPrice || undefined,
          marketPrice: v.marketPrice || undefined,
          searchImages: this.formatSearchFormData(v.searchImages,v.specifications)
        }
        this.detailHasCategory = v.categoryIds
        this.detailCategoryId = v.categoryIds ? v.categoryIds[v.categoryIds.length - 1] : '';
        this.$set(this, 'self_form', _form)
      },
      immediate: true
    },
    "self_form.categoryIds": {
      handler(v) {
        if (!v || v.length < 3) return;
        this.nutrientContentSchemaRules = null
        let categoryId = this.getCategoryId(true);
        this.getJdNeedValidateField(categoryId);
        this.checkIsShowLengthWidthHeight()
         // 发货时效
        this.initPromiseConfList();
        this.requestedSaleAttrs = false;
        this.queryJdSaleAttrs();
        this.getSchemas()
        this.queryCategoryFeature()
        if((this.detailCategoryId != this.categoryId)|| this.detailCategoryIdChange){
          this.detailCategoryIdChange = true
            this.$nextTick(() => {
                this.$refs.brandIdBlock?.useBrandConfInit();
            });
        }
      },
      immediate: true
    },
    validateFieldMap(v, o) {
      this.checkValidateFieldChangeAndUpdate(v, o)
    },
    shipsValue:{
      handler(v) {
        Object.keys(v).forEach(shopId => {
          let tempId = v[shopId]
          if(tempId){
            let temps = this.shipsTemplate[shopId] || [];
            let _isWeight = false;
            let _isVolume = false;
            temps.forEach(temp => {
              if(temp.id == tempId && [2,3].includes(temp.ruleType)){
                if(temp.ruleType === 2){ // 重量
                  _isWeight = true
                }
                if(temp.ruleType === 3){ // 体积
                  _isWeight = true
                }
              }
            });
            this.isWeight = _isWeight
            this.isVolume = _isVolume
            const newRules = RULES(this)
            this.rules = {
              ...this.rules,
              length: newRules.length,
              width: newRules.width,
              height: newRules.height,
              weight: newRules.weight,
            }
          }
        });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['SetDefaultSearchImageList']),
    // 规格名更改事件处理
    handleSpecNameChanged() {
      // 规格变化后重新构建图片映射
      this.imagesHandle();
      // 用 allSaleProps 和已渲染规格名做对比，重建未渲染规格列表
      const renderedNames = new Set(this.specifications.map(s => s.name));
      this.unrenderSpecList = this.allSaleProps
        .filter(item => {
          const { valueRules = {} } = item;
          return !renderedNames.has(valueRules.title || valueRules.name);
        })
        .map(item => cloneDeep(item));
      // needlessSpecList 记录已渲染但平台不支持的规格（基础资料多出来的）
      const platformNames = new Set(this.allSaleProps.map(item => {
        const { valueRules = {} } = item;
        return valueRules.title || valueRules.name;
      }));
      this.needlessSpecList = this.specifications
        .filter(s => !platformNames.has(s.name))
        .map(item => cloneDeep(item));
    },
    checkValidateFieldChangeAndUpdate(newVal, oldVal) {
      const {checkNameBrand: oldCheckNameBrand, popNameLength: oldPopNameLength} = oldVal;
      const {checkNameBrand, popNameLength} = newVal;
      if (!!oldCheckNameBrand !== !!checkNameBrand) {
        this.updateField('brand', !!checkNameBrand)
      }
      if (!!oldPopNameLength !== !!popNameLength) {
        this.updateField('title', !!popNameLength)
      }
    },
    // 更新字段
    updateField(fieldName, isNew) {
      if (fieldName === 'title') {
        this.rules.title[1].validator = isNew ? validateTitle2 : validateTitle
      }
      if (fieldName === 'brand') {
        this.rules.brandId = isNew ? [
          {required: true, message: '请补充品牌'},
          {validator: contextWrap(validateBrandId, this)}
        ] : []
      }
    },
    async getJdNeedValidateField(categoryId) {
      let fieldMap = await getJdNeedValidateField({
        categoryId
      });
      if (fieldMap) {
        this.validateFieldMap = fieldMap
      }
    },
    async checkIsShowLengthWidthHeight(categoryId) {
      this.isShowLWH = await getIsShowLengthWidthHeight({
        categoryId: this.categoryId,
        shopId: this.shopId
      })
      const newRules = RULES(this)
      this.rules = {
        ...this.rules,
        length: newRules.length,
        width: newRules.width,
        height: newRules.height,
        weight: newRules.weight,
      }
    },
    async valid_form() {
      return new Promise(async (resolve) => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        
        const result = await this.valiLikeColorPics('IB-'); // 商品图片
        const resultSearchPics = await this.valiLikeColorPics('IB-Long'); // 商品长图
        if (!result || !resultSearchPics){
          resolve(false);
          return false;
        }
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        if (this.$refs.jdSpecification) {
          const jdSpecificationValid = await this.$refs.jdSpecification.validateSpecValueForm();
          if (!jdSpecificationValid) {
              resolve(false);
              return;
          }
        }
        const specificationsValid = this.validateSpecifications();
        this.specificationsValidResult = specificationsValid;
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        const skuPropsValid = this.valid_skuProp();
        if (skuPropsValid !== true) {
          this.specificationsValidResult = skuPropsValid;
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    // 校验sku属性
    valid_skuProp() {
      const skuList = this.skuList || []
      const requiredAttrs = this.skuPropList.filter(item => item.isRequired)
      let isValid = true
      requiredAttrs.forEach(item => {
        skuList.forEach(sku => {
          const skuPropValues = sku.skuPropValues || []
          const findVal = skuPropValues.find(propValue => propValue.attrId === item.id && (propValue.attrValues || []).filter(Boolean).length)
          if(!findVal) {
            isValid = 'SKU属性必填项没有填写！'
            return
          }
        })
      })
      return isValid
    },

    // 处理搜索图逻辑
    formatSearchFormData(searchImages, specifications) {
      if (!searchImages || !specifications) return searchImages;
      
      // 获取所有规格值
      const allValues = specifications.reduce((acc, spec) => {
        return acc.concat(spec.values || []);
      }, []);

      // 处理每个搜索图项
      return searchImages.map(searchItem => {
        // 查找匹配的规格值
        const matchedValue = allValues.find(value => value.value === searchItem.colorId);
        if (matchedValue) {
          return {
            ...searchItem,
            imageUrls: searchItem.imageUrls,
            colorId: matchedValue.valueKey
          };
        }
        return searchItem;
      });
    },

      // 处理搜索图逻辑
      formatSearchFormDataParams(searchImages, specifications) {
      if (!searchImages || !specifications) return searchImages;
      
      // 获取所有规格值
      const allValues = specifications.reduce((acc, spec) => {
        return acc.concat(spec.values || []);
      }, []);

      // 处理每个搜索图项
      return searchImages.map(searchItem => {
        // 查找匹配的规格值
        const matchedValue = allValues.find(value => value.valueKey === searchItem.colorId);
        if (matchedValue) {
          return {
            ...searchItem,
            imageUrls: searchItem.imageUrls,
            colorId: matchedValue.value
          };
        }
        return searchItem;
      });
    },

    method_getFormData(cb) {
      return new Promise(async (resolve, reject) => {
        // 先校验图片
        this.validPage().then((valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resolve(false)
            return;
          }
          const [images, transparentImages] = this.getImageInfo()
          const [lengthImages, transparentImagesLong] = this.getImageLongInfo()
          const spuPromiseConfig = this.handlePromiseConfig();

          const [specifications, skuList] = this.getSpecificationData()
          let skuListImgError = false
          const skuListImgProps = ['whiteBackGroundPicUrl', 'searchImages', 'skuImage']
          skuList.forEach(sku => {
            // 如果sku的发货时效可选项（sku中发货时效列不显示）， 则sku.promiseConfig为[]
            if(!this.skuPromiseConfList.length) {
              sku.promiseConfig = []
            }
            sku.imageUrl = sku[this.skuSpecificationsKey][0].imageUrl
            sku.squareSpecImages = this.skuImageType === 11 ? sku.skuImage : ''
            sku.rectangleSpecImages = this.skuImageType === 34 ? sku.skuImage : ''
            skuListImgProps.forEach(imgProp => {
              const errKey = `${imgProp}_errMsg`
              if(sku[errKey]) {
                skuListImgError = true
                return
              }
              delete sku[errKey]
            })
            delete sku.skuImage
          })
          if(skuListImgError) {
            this.$message.error('请完善规格明细')
            resolve(false)
            return
          }
          let _formdata = cloneDeep(this.self_form)
          const _categoryIds = _formdata.categoryIds
          const c_names = this.$refs.cinput.method_getCategoryNames()
          const categoryId = _categoryIds[_categoryIds.length - 1]
          const categoryName = c_names[c_names.length - 1]
          _formdata = {
            ..._formdata,
            weight: this.self_form.weight || 0,
            width: this.self_form.width || 0,
            length: this.self_form.length || 0,
            height: this.self_form.height || 0,
            categoryId,
            categoryName,
            multiCategoryId: categoryId,
            multiCategoryName: categoryName,
            skuList,
            specifications,
            images,
            lengthImages,
            transparentImages,
            density: this.density,
            discount: this.discount,
            isOnshelf: this.isOnshelf,
            itemPropValues: this.handleItemPropValues(_formdata.itemPropValues),
            shopBrandConf: this.mergeHiddenShopData(cloneDeep(_formdata.brandId), this.originalShopBrandConf, this.shopList),
            templateConfig: (() => {
              let current = JSON.parse(this.handleTemplateConfig());
              current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
              return JSON.stringify(current);
            })(),
            promiseConfig: JSON.stringify(spuPromiseConfig),
            shopId: this.shopId,
            searchImages: this.formatSearchFormDataParams(_formdata.searchImages,this.specifications)
          }
          // console.log(_formdata, skuList, '----_formdata---') 
          // resolve(false)
          // return
          resolve(_formdata)
        })
      })
    },
    handleItemPropValues(itemPropValues) {
      // 对itemPropValues中attrValues为空的值进行过滤，同时与之对应的expands，units也要对应处理
      itemPropValues.forEach(itemProp => {
        if(itemProp.attrValues?.length) {
          let attrValues = [], expands = [], units = [];
          itemProp.attrValues.forEach((v, i) => {
            if(v) {
              attrValues.push(v);
              itemProp.expands?.length && expands.push(itemProp.expands[i]);
              itemProp.units?.length && units.push(itemProp.units[i]);
            }
          })
          itemProp.attrValues = attrValues;
          if(itemProp.expands?.length) itemProp.expands = expands;
          if(itemProp.units?.length) itemProp.units = units;
        } else {
          if(itemProp.expands?.length) itemProp.expands = [];
          if(itemProp.units?.length) itemProp.units = [];
        }
      })
      return itemPropValues
    },
    // 给批量修改类目和属性获取表单值用
    method_getFormData2() {
      return new Promise(async (resolve, reject) => {

        this.$refs.cateprops.$refs.form.validate((c_valid) => {
          if (c_valid) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                let _formdata = JSON.parse(JSON.stringify(this.self_form))
                const _categoryIds = _formdata.categoryIds
                const c_names = this.$refs.cinput.method_getCategoryNames()
                const categoryName = c_names[c_names.length - 1]
                const categoryId = _categoryIds[_categoryIds.length - 1]
                _formdata = {
                  ..._formdata,
                  categoryId,
                  categoryName,
                  multiCategoryId: categoryId,
                  multiCategoryName: categoryName,
                }
                resolve(_formdata)
              } else {
                this.$message.error('请完善表单')
                resolve(false)
              }
            })
          } else {
            this.$message.error('请完善商品属性')
            resolve(false)
          }
        })
      })
    },
    updateCategoryIds(ids) {
      this.self_form.categoryIds = ids;
    },
    // 获取SpValue
    getSpItem(valueKey, prop) {
      let spItem = null
      try {
        this.specifications.forEach(sp => {
          sp.values.forEach(spv => {
            if (spv.valueKey == valueKey && spv.checked) {
              spItem = spv
              throw new Error('已找到')
            }
          })
        })
      } catch (error) {
        if (spItem) {
          return prop ? spItem[prop] : spItem
        } else {
          return ''
        }
      }
    },
    // 京东平台需要提取出初始化规格相关信息的方法
    // 初始化规格相关数据需要在选择类目后
    // 通过类目属性接口，过滤掉已有规格中不在平台类目属性范围下的规格值
    async initSp(v, platformSp) {
      // const P_names = platformSp.map(item => item.name)
      // let ori_specifications = JSON.parse(JSON.stringify(v.specifications))
      let ori_specifications = cloneDeep(v.specifications)
      // const ori_sp_order_map = {} // 原规格的顺序map

      if (ori_specifications && ori_specifications.length) {
        
        // 初始化原规格顺序map
        // ori_specifications.forEach((osp, oi) => {
        //   ori_sp_order_map[osp.nameKey] = oi
        // })

        let specifications = cloneDeep(platformSp)

        // 拿原规格信息剩下的数据对 -1 的进行填充 最后将不够填充的-1过滤掉
        specifications = specifications.map(item => {
          if (item.values !== -1) {
            let _item = {
              ...item,
              values: item.values.map(iv => ({
                ...iv,
                name: (item.valueItemRule.name || item.valueItemRule.title),
                propId: item.valueItemRule.id
              }))
            }
            delete _item._psp_id
            return _item
          } else if (ori_specifications.length > 0) {
            const p_name = item.name
            const sp = ori_specifications.splice(0, 1)[0]
            return {
              ...sp,
              name: p_name,
              values: sp.values.map(iv => ({
                ...iv,
                propId: item._psp_id
              }))
            }
          } else {
            return -1
          }
        }).filter(item => item !== -1)
        // 排序
        // specifications.sort((a, b) => {
        //   return ori_sp_order_map[a.nameKey] - ori_sp_order_map[b.nameKey]
        // })
        this.specifications = cloneDeep(specifications);
      }
      await this.imagesHandle()
      this.$nextTick(() => {
        this.validPage();
      })
    },
   
    async imagesHandle() {
      const v = this.form;
      await this.queryJdSaleAttrs()
      let platformSp = this.saleAttrs.sort((a, b) => {
        return a.orderSort - b.orderSort
      })
      let _imagesMap = {
        "0000000000": []
      } // 图片索引
      let _lengthImagesMap = {  // 新增长图 Map
        "0000000000": []
      }
      let _transparentImagesMap = {
        "0000000000": ""
      } // 透图索引

      const img_value_valueKey_map = { // 颜色类型的value与valueKey的map 接下来的图片初始化
        "0000000000": "0000000000"
      } 

      if (this.specifications?.length) {
        let colorTypeName = "" // color类型的规格名 用于之后的图片数据初始化
        // 第一次遍历将原规格信息有的填入specifications 没有的先置为-1
        platformSp.forEach(psp => {
          if (psp.features.find(f => f.key === 'color')) {
            colorTypeName = psp.name
          }
        })

        // 查看现在初始化的规格信息是否有颜色类型的，有的话需要初始化图片数据
        this.specifications.forEach(sp => {
          if (sp.name === colorTypeName) {
            sp.values.forEach(spv => {
              const {valueKey, value, imageUrl} = spv;
              img_value_valueKey_map[value] = valueKey;
              _imagesMap[valueKey] = imageUrl ? [imageUrl] : []
              _lengthImagesMap[valueKey] = [] // 初始化每个颜色的长图数组为空
              _transparentImagesMap[valueKey] = ""
            })
          }
        })
      }
      if (v.images && v.images.length) { // 填充商品图片
        v.images.forEach(item => {
          if (_imagesMap.hasOwnProperty(img_value_valueKey_map[item.colorId])) {
            _imagesMap[img_value_valueKey_map[item.colorId]] = item.imageUrls
          }
        })
      }

      // 新增长图数据处理逻辑
      if (v.lengthImages && v.lengthImages.length) {
        v.lengthImages.forEach(item => {
          if (_lengthImagesMap.hasOwnProperty(img_value_valueKey_map[item.colorId])) {
            _lengthImagesMap[img_value_valueKey_map[item.colorId]] = item.imageUrls
          }
        })
      }

      if (v.transparentImages && v.transparentImages.length) { // 填充商品透图数据
        v.transparentImages.forEach(item => {
          if (_transparentImagesMap.hasOwnProperty(img_value_valueKey_map[item.colorId])) {
            _transparentImagesMap[img_value_valueKey_map[item.colorId]] = item.imageUrl
          }
        })
      }
      this.$nextTick(() => {
        if(this.showSearchImgType == 2 && this.sstjggCat){
          const images = this.sstjggCat == 1 ? _imagesMap : _lengthImagesMap
          Object.keys(images).forEach(colorId => {
            if(colorId == '0000000000' && !images[colorId].length) return
            this.skuList.forEach((sku, index) => {
              if (!sku.searchImages && sku._skuid.includes(colorId)) {
                this.$set(sku, 'searchImages', images[colorId][0])
                this.handleImgLoad(sku, 'searchImages', index)
              }
            })
          })
        }
      })

      this.imagesMap = _imagesMap
      this.lengthImagesMap = _lengthImagesMap  // 设置长图 Map
      this.transparentImagesMap = _transparentImagesMap
    },
    // 获取了当前类目下的平台方提供的规格与规格值
    prop4get(spArr) {
      if (this.isBatchCategory) {
        return;
      }
      if (!spArr) return false;
      let { attrProperties, categoryProperties } = spArr || {}
      const { templateData, templateType } = categoryProperties;
      let newSpArray = JSON.parse(templateData);
      newSpArray = newSpArray.map(item => {
        if (templateType == 2) {
          item['valueRules'] = JSON.parse(item.valueRules)
        } else {
          // 老数据处理
          const { id } = item;
          // delete item['id'];
          const newItem = {
            attrId: id,
            valueRules: {
              ...item
            }
          }
          return newItem;
        }
        return item;
      })
      const defaultSpecifications = cloneDeep(this.form.specifications);
      const { newSpec, unrenderList, needlessSpecList, allSaleProps } = gernerateJDSpecs(newSpArray, defaultSpecifications, attrProperties)
      // this.specifications = cloneDeep(newSpec)
      this.unrenderSpecList = _.cloneDeep(unrenderList);
      this.needlessSpecList = _.cloneDeep(needlessSpecList);
      this.allSaleProps = allSaleProps;
      // 刷新规格组件重新渲染
      if (this.$refs.jdSpecification) {
        this.$refs.jdSpecification.reRenderPage();
      }
      // newSpArray?.sort((a, b) => {
      //   return a.orderSort - b.orderSort
      // })
      this.initSp(this.form, newSpec)
    },
    prop3get(propList) {
      this.skuPropList = propList.filter(item => item.features.find(f => f.key === 'attrLevel' && f.fvalue === '1'))
    },
    // 校验颜色类型规格图片
    async valiLikeColorPics(refStart='IB-') {
      try {
        const promiseList = this.colorIds.map(item => {
          if(this.$refs[refStart + item] && this.$refs[refStart + item][0]) {
            return this.$refs[refStart + item][0].validForm()
          }
          return true
        })
        const res = await Promise.all(promiseList)
        return res.every(item => !!item)
      } catch (error) {
        return false
      }
    },
    // 引用套图
    useGroupImages(data, type) {
      const mainImagesRef = this.$refs['IB-0000000000'][0]
      const [imageUrls, transparentImages] = mainImagesRef.getData()
      const {mainImages=[], detailImages=[], speImages=[]} = data
      let pic = [], description = [];
      if(type === 'add') {
        pic = [...imageUrls].filter(Boolean)
      }
      if(mainImages.length) {
        mainImagesRef.setData([[...pic, ...mainImages].filter(Boolean).slice(0, 10), transparentImages])
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specValue.imageUrl) {
              return;
          }
          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specValue.value);
          if (matchedImage) {
            specValue.imageUrl = matchedImage.imgUrl;
            const $colorIdRef = this.$refs['IB-'+specValue.valueKey]
            if($colorIdRef) {
              $colorIdRef[0].setData([[matchedImage.imgUrl]])
            }
          }
        });
      }
    },
    getGroupImagesList (list){
      this.showGroupImages = !!list?.length
    },
    // 维护编辑套图
    editGroupImages(){
      this.changeToBase('openGroupImgs')
    },
    // 获取商品图片信息
    getImageInfo() {
      const images = []
      const transparentImages = []
      this.colorIds.forEach(colorId => {
        const [imageUrls, imageUrl] = this.$refs['IB-'+colorId][0].getData()
        let _colorId = colorId === '0000000000' ? '0000000000' : this.getSpItem(colorId, 'value');
        const _image = {
          colorId: _colorId,
          imageUrls
        }
        const _transImage = {
          colorId: _colorId,
          imageUrl
        }
        images.push(_image)
        transparentImages.push(_transImage)
      })
      return [images, transparentImages]
    },
    // 获取长图图片信息
     // 获取商品图片信息
     getImageLongInfo() {
      const lengthImages = []
      const transparentImagesLong = []
      this.colorIds.forEach(colorId => {
        let imageUrls = []
        let imageUrl = ''
        const refs = this.$refs['IB-Long'+colorId];
        if (refs && refs.length > 0) {
            [imageUrls, imageUrl] = refs[0].getData();
            // 后续使用 imageUrls 和 imageUrl 的代码
        } else {
            console.warn(`未找到 'IB-Long${colorId}' 对应的引用`);
        }
        let _colorId = colorId === '0000000000' ? '0000000000' : this.getSpItem(colorId, 'value');
        const _image = {
          colorId: _colorId,
          imageUrls
        }
        const _transImage = {
          colorId: _colorId,
          imageUrl
        }
        lengthImages.push(_image)
        transparentImagesLong.push(_transImage)
      })
      return [lengthImages, transparentImagesLong]
    },
    imageUpload(v) {
      const { valueKey, imageUrl } = v || {}
      const curRef = this.$refs['IB-'+valueKey]
      if(imageUrl && curRef) {
        let [imageUrls, transparentImages] = curRef[0].getData()
        imageUrls[0] = imageUrl
        curRef[0].setData([imageUrls, transparentImages])
      }
    },
    // 一键追加到所有sku图(需过滤重复图)
    pushSkuImg() {
      const [imageUrls, imageUrl] = this.$refs['IB-0000000000'][0].getData()
      this.colorIds.forEach((colorId) => {
        if (colorId === '0000000000') return;
        const [skuImageUrls] = this.$refs['IB-'+colorId][0].getData()
        const filterImgs = imageUrls.filter(img => !skuImageUrls.includes(img))
        const concatImgs = [...skuImageUrls, ...filterImgs].slice(0, 10)
        this.setSkuImg(colorId, [concatImgs, imageUrl])
      })
    },
    // 覆盖所有sku图片
    coverSkuImg() {
      const [imageUrls, imageUrl] = this.$refs['IB-0000000000'][0].getData()
      this.colorIds.forEach((colorId) => {
        if (colorId === '0000000000') return;
        this.setSkuImg(colorId, [imageUrls, imageUrl])
      })
    },
    // 应用商品图片
    applyMainImg(colorId) {
      const [imageUrls, imageUrl] = this.$refs['IB-0000000000'][0].getData()
      this.setSkuImg(colorId, [imageUrls, imageUrl])
    },
    setSkuImg(colorId, imgs) {
      if (colorId === '0000000000' || !this.$refs['IB-'+colorId]) return;
      let [imageUrls] = imgs;
      this.$refs['IB-'+colorId][0].setData(imgs)
      this.updateSkuImg(colorId, imageUrls)
    },
    updateSkuImg(colorId, imageUrls) {
      this.specifications.forEach(sp => {
        sp.values.forEach(spv => {
          if (spv.valueKey == colorId) {
            spv.imageUrl = imageUrls[0]
            window.__spcificationImg_changed = colorId; 
          }
        })
      })
    },
    imageBlockChange(colorId) {
      if (colorId === '0000000000') return;
      const [imageUrls] = this.$refs['IB-'+colorId][0].getData()
      if(this.showSearchImgType == 2 && this.sstjggCat == 1 && imageUrls[0]){
        this.skuList.forEach((sku, index) => {
          if (!sku.searchImages && sku._skuid.includes(colorId)) {
            this.$set(sku, 'searchImages', imageUrls[0])
            this.handleImgLoad(sku, 'searchImages', index)
          }
        })
      }
      this.validPage()
    },
    imageBlockLongChange(colorId) {
      if (colorId === '0000000000') return;
      const [imageUrls] = this.$refs['IB-Long'+colorId][0].getData()
      let searchImages = cloneDeep(this.self_form.searchImages||[])
      if(imageUrls.length == 0){
        // 如果图片长度为0，找到并移除对应colorId的项
        const targetIndex = searchImages.findIndex(item => item.colorId == colorId)
        if (targetIndex !== -1) {
          searchImages.splice(targetIndex, 1)
        }
        this.SetDefaultSearchImageList(searchImages)
        this.$set(this.self_form, 'searchImages', searchImages)
      }
      if(this.showSearchImgType == 2 && this.sstjggCat == 2 && imageUrls[0]){
        this.skuList.forEach((sku, index) => {
          if (!sku.searchImages && sku._skuid.includes(colorId)) {
            this.$set(sku, 'searchImages', imageUrls[0])
            this.handleImgLoad(sku, 'searchImages', index)
          }
        })
      }
      this.validPage()
    },
    // 一键追加到所有sku长图
    pushSkuLongImg() {
      const [imageUrls, imageUrl] = this.$refs['IB-Long0000000000'][0].getData()
      this.colorIds.forEach((colorId) => {
        if (colorId === '0000000000') return;
        const [skuImageUrls] = this.$refs['IB-Long'+colorId][0].getData()
        const filterImgs = imageUrls.filter(img => !skuImageUrls.includes(img))
        const concatImgs = [...skuImageUrls, ...filterImgs].slice(0, 10)
        this.setSkuLongImg(colorId, [concatImgs, imageUrl])
      })
    },
    // 设置sku长图
    setSkuLongImg(colorId, imgs) {
      if (colorId === '0000000000') return;
      this.$refs['IB-Long'+colorId][0].setData(imgs)
      this.imageBlockLongChange(colorId)
    },
    coverSkuLongImg() {
      const [imageUrls, imageUrl] = this.$refs['IB-Long0000000000'][0].getData()
      this.colorIds.forEach((colorId) => {
        if (colorId === '0000000000') return;
        this.setSkuLongImg(colorId, [imageUrls, imageUrl])
      })
    },

    // 修改搜索图
    imageSettingBlockChangeSearchImg({imgUrl,colorId}, onlyHandleEmpty){
      const searchImages = cloneDeep(this.self_form.searchImages || [])
      if (this.self_form.searchImages.length) {
        // 已经添加过规格图
        const targetIndex = this.self_form.searchImages.findIndex(item => item.colorId == colorId)
        // 如果在规格图上没找到，是第一次添加
        if (targetIndex === -1) {
          searchImages.push({
            imageUrls: imgUrl,
            colorId: colorId
          })
        } else {
          // 规格图里找到过了
          if (searchImages[targetIndex].imageUrls !== imgUrl) {
            // 如果 imgUrl 等于 specImage，则从 searchImages 中去除这一项
            // searchImages.splice(targetIndex, 1);
          } else {
            // 如果 imgUrl 不等于 specImage，则更新 specImage
            searchImages[targetIndex] = {
              imageUrls: imgUrl,
              colorId: colorId
            };
          }
        }
      } else {
        // 如果灭有规格图，第一次添加
        searchImages.push({
          imageUrls: imgUrl,
          colorId: colorId
        })
      }
      // 更新skuList中对应项的searchImages
      if (this.skuList && this.skuList.length) {
        this.skuList.forEach((sku, index) => {
          if (sku._skuid.includes(colorId)) {
            this.$set(sku, 'searchImages', imgUrl)
            this.handleImgLoad(sku, 'searchImages', index)
          }
        })
      }
      // searchImages 存到 vuex 
      this.SetDefaultSearchImageList(searchImages)
      this.$set(this.self_form, 'searchImages', searchImages)
    },

    handleTemplateConfig() {
      const arr = [];
      Object.keys(this.shipsValue).forEach(key=> {
        this.shipsTemplate[key].forEach(item=> {
          if(item.id == this.shipsValue[key]){
            const channel = this.shopList.find(shop => shop.id == key)?.channel
            arr.push({
              shopId: key,
              templateId: item.id,
              templateName: item.name,
              ruleType:item.ruleType,
              channel
            })
          }
        })
      })
      return JSON.stringify(arr);
    },
    handlePromiseConfig() {
      const arr = [];
      Object.keys(this.promiseTemplateValues).forEach(key=> {
        arr.push({
          shopId: key,
          promiseId: this.promiseTemplateValues[key],
        })
      })
      return cloneDeep(arr);
    },
    getCategoryId(max3) {
      let categoryIds = this.self_form?.categoryIds
      if(!categoryIds?.length) return ''
      let categoryId = categoryIds[categoryIds.length - 1];
      if(max3) {
        categoryId = categoryIds.length > 3 ? categoryIds[2] : categoryIds[categoryIds.length - 1];
      }
      return categoryId
    },
    // 处理发货时效
    async initPromiseConfList() {
      let categoryId = this.categoryId;
      if (!categoryId) return;
      let promiseTemplateValues = {};
      let shopIds = this.shopList.map(({id}) => id);
      let promiseConfList = [];
      let skuPromiseConfList = [];
      if(shopIds.length) {
        const data = await getJdSellerDeliverySendPromiseTemplate({shopIds: shopIds.join(','), categoryId});
        if(data) {
          Object.keys(data).forEach(shopId => {
            const categorySendPromise = data[shopId].categorySendPromise || {};
            const { promiseTemplateDtoList=[], supportFlag, requiredFlag, bindType } = categorySendPromise;
            if(supportFlag) {
              let curShop = this.shopList.find(shop => shop.id == shopId);
              let newItem = {
                requiredFlag,
                shopId,
                icon: curShop.icon,
                shopName: curShop.simpleTitleConfig === 1 ? (curShop.shortTitle || curShop.title) : curShop.title,
                channelIcon: curShop.channelIcon,
                channelName: curShop.channelName,
                promiseTemplateDtoList
              };
              if(bindType == 1) {
                promiseConfList.push(newItem);
                promiseTemplateValues[shopId] = '';
                // promiseTemplateValues[shopId] = promiseTemplateDtoList.find(promise => promise.recommendFlag)?.templateId;
              } if(bindType == 2) {
                skuPromiseConfList.push(newItem);
              }
              // skuPromiseConfList.push(newItem);
            }
      
          });
          (this.self_form.promiseConfig || []).map(promise => {
            promiseTemplateValues[promise.shopId] = promise.promiseId || promiseTemplateValues[promise.shopId];
          });
        }
      }
      this.promiseTemplateValues = promiseTemplateValues;
      this.promiseConfList = promiseConfList;
      this.skuPromiseConfList = skuPromiseConfList;
    },
    toPromiseConfig(row) {
      const that = this
      let values = {};
      this.skuPromiseConfList.map(item=>{
        values[item.shopId] = '';
      })
      if(row && row.promiseConfig?.length) {
        row.promiseConfig.map(promise => {
          values[promise.shopId] = promise.promiseId || values[promise.shopId];
        });
      }
      this.$refs.PromiseConfigDialogRef.method_open({
        promiseConfList: this.skuPromiseConfList,
        values,
        saveFn(promiseConfig) {
          if(!row) {
            that.skuList.forEach(sku => {
              sku.promiseConfig = promiseConfig;
            })
          } else {
            row.promiseConfig = promiseConfig;
          }
        }
      });
    },
    getPromiseText(row){
      let text = '';
      let selectedList = row.promiseConfig.filter(item => item.promiseId);
      if(selectedList.length == 0) {
        text = '未配置';
      } else if(selectedList.length < this.skuPromiseConfList.length){
        text = '部分配置';
      } else {
        text = '已配置';
      }
      return text;
    },
    editSkuCateprops(row = {}, isBatch) {
      const that = this
      this.$refs.SkuCategoryPropDialogRef.method_open({
        row: cloneDeep(row),
        categoryIds: this.self_form.categoryIds,
        sureFn(newRow) {
          if (isBatch) {
            that.skuList.forEach(sku => {
              sku.skuPropValues = newRow.skuPropValues;
            })
          } else {
            row.skuPropValues = newRow.skuPropValues;
          }
          that.specificationsFieldChanged()
        }
      });
    },
    getNutrientBtnText(nutrientContent) {
      if (!nutrientContent || Object.keys(nutrientContent).length === 0) {
        return '设置食品安全';
      }
      return '查看已设置信息';
    },
    async getRuleComponents(componentCodeList){
      const rules = await getJdCategoryRuleTemplatesComponents({
        shopId: this.shopId,
        lastCategoryId: this.categoryId,
        componentCodeList: componentCodeList.join(','),
        thirdCategoryId: this.getCategoryId(true),
        scene: 'pop',
        templateId: 1
      });
      return rules || {}
    },
    async editNutrientContent(row, isBatch) {
      const that = this;
      // 如果还没有获取过 schema rules，先获取
      if (!this.nutrientContentSchemaRules) {
        // const schemaRules = nutrientContentSchemaRules || await that.getRuleComponents(['SkuNutrientContent']);
        const schemaRules = await that.getRuleComponents(['SkuNutrientContent']);
        that.nutrientContentSchemaRules = (schemaRules || []).find(s => s.componentCode === 'SkuNutrientContent');
      }
      this.$refs.NutrientContentDialogRef.method_open({
        row,
        schemaRules: that.nutrientContentSchemaRules,
        isBatch,
        sureFn(nutrientContent) {
          if (isBatch) {
            that.skuList.forEach(sku => {
              that.$set(sku, 'nutrientContent', cloneDeep(nutrientContent));
            });
          } else {
            row.nutrientContent = cloneDeep(nutrientContent);
          }
        },
      });
    },
    batchSetSearchImages() {
      this.$refs.SetSearchImagesRef.method_open({
        sureFn: (url) => {
          this.skuList.forEach((sku, index) => {
            this.$set(sku, 'searchImages', url)
            this.handleImgLoad(sku, 'searchImages', index)
          })
        },
      })
    },
    switchSkuImageType() {
      this.skuImageType = this.skuImageType == 11 ? 34 : 11
      this.skuList.forEach((sku, index) => {
        const colorId = this.colorIds.find(colorId => sku._skuid.includes(colorId))
        const $refs = this.$refs[`IB-${this.skuImageType == 34 ? 'Long' : ''}`+colorId];
        let imageUrl = ''
        if(colorId && $refs?.length) {
          const [imageUrls] = $refs[0].getData()
          imageUrl = imageUrls?.[0] || ''
        }
        this.$set(sku, 'skuImage', imageUrl)
        this.handleImgLoad(sku, 'skuImage', index)
      })
    },
     handleImgLoad(row, key, index) {
      this.$nextTick(async () => {
        let errMsg = await this.$refs[`${key}_${index}`]?.method_validImage()
        this.$set(row, `${key}_errMsg`, errMsg)
        this.$nextTick(() => {
          this.getErrorCount()
        });
      })

    },
    handleSkuListPic(row, url, key){
      row[key] = url || ''
      if(!url) {
        this.$set(row, `${key}_errMsg`, '')
        this.$nextTick(() => {
          this.getErrorCount()
        });
      }
    },
    // 处理京东详情 templateConfig
    initTemplateConfig(templateList = []) {
      const ships = {};
      this.shopList.forEach((shop) => {
        ships[shop.id] = '';
      });
      const templateConfigMap = {};
      this.self_form.templateConfig = this.self_form.templateConfig ? this.self_form.templateConfig : []
      this.self_form.templateConfig.forEach(item => {
        templateConfigMap[item.shopId] = {
          templateId: item.templateId,
          templateName: item.templateName,
          ruleType: item.ruleType,
        };
      })
      templateList.forEach(item => {
        if(!templateConfigMap[item.shopId]){
          templateConfigMap[item.shopId] = {
          templateId: item.templateId,
          templateName: item.templateName,
          ruleType: item.ruleType,
        };
        }
      })
      this.templateConfigMap = templateConfigMap;
      Object.keys(templateConfigMap).forEach(key => {
        ships[key] = templateConfigMap[key].templateId
      })
      this.shipsValue = ships;
      this.initShipsTemplate(templateConfigMap);
    },
    // 处理每个店铺下拉框
    initShipsTemplate(templateConfigMap) {
      const shipsTemplate = {};
      this.shopList.forEach(shop => {
        shipsTemplate[shop.id] = []
      });
      Object.keys(templateConfigMap).forEach(key=> {
        shipsTemplate[key] = [{
          id: templateConfigMap[key].templateId || '',
          name: templateConfigMap[key].templateName || '',
          ruleType:templateConfigMap[key].ruleType || 1
        }]
      })
      this.shipsTemplate = shipsTemplate;
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({shopType: 'JdShop'});
      // 上架设置
      this.isOnshelf = this.self_form.isOnshelf ? this.self_form.isOnshelf : (res?.shelfState || 1);
      // 图片配置
      this.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
      // 运费模板
      this.initTemplateConfig(res?.templateList || []);
      this.initPromiseConfList();
      if(this.autoCropImageConfigList.length){// 异步获取到不用校验图片尺寸的情况，重新校验一下刷新状态
          setTimeout(() => {
              this.validPage();
          }, 3000)
      }
    },
    // 获取模板
    async getTemplateList(userId, shopId) {
      const list = await getJdTemplates({userId: userId}, { isNeedFailNotice: true });
      this.$set(this.getTemplateFail, shopId, !list)
      if (list) {
        return list.map(ship => {
          return {
            name: ship.template_name,
            id: ship.id.toString(),
            ruleType:ship.rule_type
          }
        });
      }
      return [];
    },
    async changeSelect(shopId, userId) {
      const list = await this.getTemplateList(userId, shopId);
      const idx = list?.findIndex(item => item.id === this.shipsValue[shopId]);
      if (idx === -1) {
          this.shipsValue[shopId] = '';
      }
      this.$set(this.shipsTemplate, shopId, list || []);
    },
    
    async getSchemas() {
      let categoryId = this.categoryId;
      if (!categoryId) return;
      const data = await getJdSchemas({
        shopId: this.shopId,
        categoryId,
        scene: 'pop',  // scene = "vc" 表示VC商品; scene = "pop" 表示POP商品;
      })
      this.schemas = data
      console.log(data, '---getSchemas---')
    },
    async queryJdSaleAttrs() {
      let categoryId = this.categoryId;
      if (!categoryId || this.requestedSaleAttrs) return;
      const data = await getJdSaleAttrs({
        shopId: this.shopId,
        categoryId,
      })
      this.saleAttrs = data;
      this.requestedSaleAttrs = true;
    },
    async queryCategoryFeature() {
      let categoryId = this.getCategoryId(true);
      if (!categoryId) return;
      const res = await getCategoryFeature({
        categoryId,
        shopId: this.shopId
      })
      const features = res?.result[categoryId]?.features || {}
      const {sstjtCat, sstjggCat, isCtzs, zbbt} = features
      this.showSearchImgType = sstjtCat    // 1支持搜索图推荐，2支持并必填搜索图推荐
      this.sstjggCat = sstjggCat  //  判断搜索推荐图可传图片规格。 1是1:1， 2是3:4（长图）, 1,2时，允许将规格中的商品展示图（1：1）或商品长图（3：4）
      this.showLongImage = isCtzs
      this.zbxx_required = zbbt == 1
    },
    clickTemPlateFill(row) {
        const platformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : []
        this.self_form.itemPropValues = platformCatProp
        // this.initAttrData = platformCatProp
    },
    isCheckImg(type){
        return !this.autoCropImageConfigList.includes(type);
    },
    textLength(text) {
      return getBytesCount(text || '');
    },
  },
  created() {
    this.$store.dispatch("getJdWareLocation")
  },
  mounted() {
    this.getConf();
    getJdNoShowBrandId().then(res => {
      if (res) {
        this.noShowBrandId = res;
      }
    })
  },
  unmounted() {
      this.detailCategoryIdChange = false
  },
};
</script>

<style lang="scss" scoped>
.gray-block {
  background: #F9F9FA;
  padding: 10px;
}
.brandIdWrap {
  font-size: 12px;
  .brandIdItem + .brandIdItem {
    margin-top: 8px;
  }
}
.number-input {
  & ::v-deep input {
    text-align: left;
  }
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>